
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[festivalId]/play/[...programId]",
      function () {
        return require("private-next-pages/[festivalId]/play/[...programId].js");
      }
    ]);
  